import shadow from "../assets/images/shadow_footer.png";
import logo from "../assets/images/footer_logo.png";
import tg from "../assets/images/tg.png";
import mail from "../assets/images/mail.png";
import { Link } from "react-router-dom";
import "../assets/css/index.css"




export default function Footer() {
  return (

    <footer className="footer-home homepage-area relative mt-12 md:mt-32 py-5 md:py-10">
      <div className="container flex justify-between">
        <div className="footer_logo flex items-center gap-2">
          <img className="max-h-[42px]" src={logo} alt="" />
          <div className="flex flex-col">
            <span className="text-xl font-medium md:text-2xl text-white">
              Fl-Dating.Su
            </span>
            <span className="text-sm text-white">
              © 2025 Fl-Dating.Su - Все права защищены
            </span>
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <Link to="https://t.me/fl_assistance" className="flex gap-2 items-center font-light">
            <img src={tg} alt="" />
            <span className="opacity-75 text-white">https://t.me/fl_assistance</span>
          </Link>
          <Link to="mailto:fl-dating@mail.ru" className="flex gap-2 items-center font-light">
            <img src={mail} alt="" />
            <span className="opacity-75 text-white">fl-dating@mail.ru</span>
          </Link>
        </div>
      </div>
    </footer>
  );
}
